import { nanoid } from 'nanoid';

// OOP WITH JAVA PROJECTS
const basicJavaData = [
  // {
  //   id: nanoid(),
  //   img: '',
  //   title: '',
  //   info: '',
  //   info2: '',
  //   url: '',
  //   repo: '',
  // },

  {
    id: nanoid(),
    img: 'basicJava_code-breaker.png',
    title: 'CodeBreaker',
    info: 'This interactive tool allows users to encrypt and decrypt messages using popular ciphers like the Caesar Cipher and Vigenere Cipher.',
    info2: '',
    url: '',
    repo: 'https://github.com/Shcoobz/CodeBreaker-Cipher-App',
  },

  {
    id: nanoid(),
    img: 'basicJava_byte-sized-bakes.png',
    title: 'Byte-sized Bakes',
    info: 'This project is about managing a cake shop. It simulates the process of ordering different types of cakes with various flavors, calculating the cost, and managing orders.',
    info2: '',
    url: '',
    repo: 'https://github.com/Shcoobz/Byte-sized-Bakes',
  },

  {
    id: nanoid(),
    img: 'basicJava_vehicle-vault.png',
    title: 'Vehicle Vault',
    info: 'This application provides a realistic simulation of a parking garage management system. It features a user-friendly interface for processing vehicle reservations, managing parking spots, and handling different types of vehicles such as cars and trucks.',
    info2: '',
    url: '',
    repo: 'https://github.com/Shcoobz/Vehicle-Vault',
  },

  {
    id: nanoid(),
    img: 'basicJava_post-master.png',
    title: 'Post Master',
    info: 'This application simulates the operations of a postal office, providing an interactive way to manage and track postal items. It features a user-friendly interface, efficient item processing, and detailed financial tracking.',
    info2: '',
    url: '',
    repo: 'https://github.com/Shcoobz/Post-Master',
  },

  {
    id: nanoid(),
    img: 'basicJava_bite-bistro.png',
    title: 'Bite Bistro',
    info: 'This application provides a simulated environment for managing a restaurant. It features a user-friendly interface for order handling, including drinks and sandwiches, and showcases a simple yet effective system for calculating total sales and displaying order details.',
    info2: '',
    url: '',
    repo: 'https://github.com/Shcoobz/Bite-Bistro',
  },

  {
    id: nanoid(),
    img: 'basicJava_mighty-text-adventure.png',
    title: 'TEAMWORK: Mighty Text Adventure',
    info: 'This project is a text-based role-playing game set in a magical realm. Players navigate through various areas, encounter enemies, and engage in battles, all through text-based commands.',
    info2: '',
    url: '',
    repo: 'https://github.com/CodecoolGlobal/mighty-text-adventure-java-Shcoobz',
  },

  {
    id: nanoid(),
    img: 'basicJava_ehotel-buffet.png',
    title: 'TEAMWORK: eHotel Buffet',
    info: 'A sophisticated application designed to manage the buffet services in a hotel setting, focusing primarily on breakfast. It streamlines the guest dining experience, meal preparation, and waste management through an intuitive interface. ',
    info2: '',
    url: '',
    repo: 'https://github.com/CodecoolGlobal/ehotel-buffet-java-AdrianMonemi',
  },
];

export default basicJavaData;
